export enum GatewayEnum {
  CASH = 706,
  STRIPE = 704,
  LOYALTY = 708,
  GIFTCARD = 709,
  SQUAREUP = 710,
  APPLEPAY = 711,
  GOOGLEPAY = 712
}